const ALL = 'all'
const PROGRAMSREQUESTS = 'programs_requested'
const ACCOUNTREQUESTS = 'account_requested'
const PROGRAMS = 'programs'
const ACCOUNTS = 'accounts'

const incentiveStructureOptions = {
  UPFRONT_DISCOUNT: 'Upfront Discount Incentive',
  SEASONAL_PERFORMANCE_INCENTIVES: 'Seasonal Performance Incentive',
  CUSTOM: 'Custom'
}

const getRequestToggleOptions = (count) => [
  {
    label: 'Program Requests',
    id: PROGRAMSREQUESTS
  },
  {
    label: 'Account Requests',
    id: ACCOUNTREQUESTS
  }
]

const getTableHeadings = (type) => ([
  ...(type === PROGRAMS ?
    [{
      id: 'programName',
      header: 'PROGRAM NAME',
      isLink: true
    }] : []),
  {
    id: 'accountName',
    header: 'ACCOUNT NAME',
    isLink: type === ACCOUNTS
  },
  {
    id: 'requestedBy',
    header: 'REQUESTED BY'
  },
  {
    id: 'datetime',
    header: 'DATE AND TIME'
  },
])

export {
  getTableHeadings,
  ALL,
  PROGRAMSREQUESTS,
  ACCOUNTREQUESTS,
  PROGRAMS,
  ACCOUNTS,
  getRequestToggleOptions,
  incentiveStructureOptions
}